import { defaultDropAnimationSideEffects, DragOverlay } from '@dnd-kit/core';

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4'
      }
    }
  })
};

export const SortableOverlay = ({ children }) => (
  <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>
);
